/**
 * @file
 * Custom JavaScript functionality.
 */

(function ($, Drupal, drupalSettings) {

  /**
   * Accordion functionality.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *   Attaches behaviors for accordion items.
   */
  Drupal.behaviors.accordionContainer = {
    attach: function attach(context, settings) {

      var allAccordions = $('.paragraph--type--accordion-item .c-block__accordion-item-body', context);
      allAccordions.each(function () {
        let isOpened = $(this).siblings('.c-block__accordion-item-title').hasClass('active');
        if (!isOpened) {
          $(this).hide();
        }
      });

      $('.paragraph--type--accordion-item .c-block__accordion-item-title', context).click(function () {
        $(this).next().slideToggle(600);
        $(this).toggleClass("active");
      });
    }
  };

}(jQuery, Drupal, drupalSettings));
